import Vue                          from 'vue'
import Router                       from 'vue-router'
import Index                        from '@/components/Index'
import Callback                     from '@/components/Callback'
import Loginform                    from '@/components/Loginform'
import XDLocalStorageIframe         from '@/components/XDLocalStorageIframe'

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Index',
			component: Index,
		},
		{
			path: '/login',
			name: 'Callback',
			component: Callback,
		},
		{
			path: '/loginform',
			name: 'Loginform',
			component: Loginform,
		},
		{
			path: '/xdlocalstorage-iframe',
			name: 'XDLocalStorageIframe',
			component: XDLocalStorageIframe,
		}
	]
})
